var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7054 5.89008V2.55712H10.3795L8.01605 0.214844L5.68793 2.55712H2.35497V5.89008L0.0126953 8.2182L2.35497 10.5817V13.9076H5.68793L8.01605 16.2499L10.3795 13.9076H13.7054V10.5817L16.0477 8.2182L13.7054 5.89008ZM5.77284 4.7154C6.46633 4.7154 7.02536 5.27443 7.02536 5.97499C7.02536 6.30718 6.8934 6.62576 6.65851 6.86065C6.42361 7.09555 6.10503 7.22751 5.77284 7.22751C5.07229 7.22751 4.51325 6.66848 4.51325 5.97499C4.51325 5.27443 5.07229 4.7154 5.77284 4.7154ZM10.2946 11.7564C9.60115 11.7564 9.04212 11.1903 9.04212 10.4968C9.04212 10.1646 9.17408 9.84601 9.40897 9.61112C9.64386 9.37623 9.96245 9.24427 10.2946 9.24427C10.9881 9.24427 11.5542 9.8033 11.5542 10.4968C11.5542 10.8308 11.4215 11.1512 11.1853 11.3874C10.9491 11.6237 10.6287 11.7564 10.2946 11.7564ZM5.53932 11.7776L4.47787 10.7161L10.514 4.68002L11.5755 5.74147L5.53932 11.7776Z",
    fill: "#01B201"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckVerde);
export default __webpack_public_path__ + "static/media/checkVerde.fabab7e8f9d5ff081aae30f9c2e6fd1c.svg";
export { ForwardRef as ReactComponent };